module.exports = __webpack_public_path__ + "img/img4.0fe3fa80.0fe3fa80.jpg";